import { render, staticRenderFns } from "./CourseSettingsBlock.vue?vue&type=template&id=f3eb890a&"
import script from "./CourseSettingsBlock.vue?vue&type=script&lang=js&"
export * from "./CourseSettingsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports